import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import ApplicationAdapter from './application.js';
import { beebeeAjaxGet } from 'beebee-base/lib/utility';
import { inject } from '@ember/service';
import getConfig from 'beebee-base/lib/get-config';

var _class, _descriptor, _descriptor2;
let ContactAdapter = (_class = class ContactAdapter extends ApplicationAdapter {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "log", _descriptor2, this);
  }
  async queryRecord() {
    try {
      const response = await beebeeAjaxGet(`${getConfig(this).APP.urlApi}/contacts/me`, this.session.token);
      return response;
    } catch (error) {
      this.log.error('Error fetching contact:', error);
      throw error;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "log", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { ContactAdapter as default };
//# sourceMappingURL=contact.js.map
